__turbopack_context__.v({
  "arrow": "trending-brands-module__q-gDbG__arrow",
  "arrowNext": "trending-brands-module__q-gDbG__arrowNext",
  "arrowPrev": "trending-brands-module__q-gDbG__arrowPrev",
  "blurLayer": "trending-brands-module__q-gDbG__blurLayer",
  "desktopOnly": "trending-brands-module__q-gDbG__desktopOnly",
  "header": "trending-brands-module__q-gDbG__header",
  "image": "trending-brands-module__q-gDbG__image",
  "label": "trending-brands-module__q-gDbG__label",
  "link": "trending-brands-module__q-gDbG__link",
  "mobile": "trending-brands-module__q-gDbG__mobile",
  "mobileSlide": "trending-brands-module__q-gDbG__mobileSlide",
  "section": "trending-brands-module__q-gDbG__section",
  "slide": "trending-brands-module__q-gDbG__slide",
  "stage": "trending-brands-module__q-gDbG__stage",
  "subtitle": "trending-brands-module__q-gDbG__subtitle",
  "title": "trending-brands-module__q-gDbG__title",
  "track": "trending-brands-module__q-gDbG__track",
  "viewport": "trending-brands-module__q-gDbG__viewport",
});
